<template>
  <div class="mogujia-page">
    <div class="mogujia-card">
      <div class="mogujia-card-top">
        <img class="mogujia-logo" src="/static/images/mogujia/logo.png" alt="iDoeeoD">
        <img class="mogujia-logo-cn" src="/static/images/mogujia/logo-cn.png" alt="迹忆档案">
      </div>

      <div class="mogujia-divider"></div>

      <div class="mogujia-lock-wrap">
        <img class="mogujia-lock" src="/static/images/mogujia/lock.png" alt="档案锁">
      </div>

      <div class="mogujia-card-body">
        <button class="scan-entry" type="button" @click="handleScanClick">
          <img class="scan-icon" src="/static/images/mogujia/scan.png" alt="扫码">
          <img class="scan-tip" src="/static/images/mogujia/scan-tip.png" alt="扫码查询此物身份">
        </button>

        <img class="or-img" src="/static/images/mogujia/or.png" alt="或">

        <div class="input-wrap">
          <input
            v-model="archiveCode"
            class="archive-input"
            type="text"
            maxlength="16"
            inputmode="numeric"
            placeholder="请输入16位档案编码"
            @input="handleInput"
          >
        </div>

        <button class="confirm-entry" type="button" @click="queryData()">
          <img class="confirm-icon" src="/static/images/mogujia/yuan.png" alt="确认">
          <img class="confirm-text" src="/static/images/mogujia/queren.png" alt="确认此物身份">
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { getJSSDK } from '../../api/api'
import wx from 'weixin-js-sdk'

export default {
  name: 'MoGuJiaScan',
  data() {
    return {
      archiveCode: '',
      appId: 'wx885161c495be58a3',
      wxReady: false
    }
  },
  mounted() {
    this.initWechatJsSdk()
  },
  methods: {
    handleInput() {
      this.archiveCode = this.archiveCode.replace(/\D/g, '').slice(0, 16)
    },
    queryData(code) {
      const sourceCode = typeof code === 'string' || typeof code === 'number'
        ? code
        : this.archiveCode
      const antiCode = String(sourceCode || '').replace(/\D/g, '').slice(0, 16)
      this.archiveCode = antiCode

      if (!antiCode) {
        alert('请输入16位档案编码')
        return
      }

      if (!/^\d{16}$/.test(antiCode)) {
        alert('请输入16位数字档案编码')
        return
      }

      this.goToResult(antiCode)
    },
    handleScanClick() {
      if (!this.wxReady) {
        console.warn('蘑菇家微信 JSSDK 尚未就绪')
        return
      }
      wx.scanQRCode({
        needResult: 1,
        scanType: ['qrCode'],
        success: res => {
          const scanResult = res.resultStr || ''
          let scanCode = scanResult

          if (scanResult.startsWith('http')) {
            const parts = scanResult.split('/')
            scanCode = parts.length ? parts[parts.length - 1] : ''
          }

          scanCode = String(scanCode).replace(/\D/g, '').slice(0, 16)
          this.archiveCode = scanCode
          this.queryData(scanCode)
        },
        fail: err => {
          console.error('蘑菇家调起扫码失败:', err)
        }
      })
    },
    initWechatJsSdk() {
      const url = encodeURIComponent(window.location.href.split('#')[0])
      getJSSDK(url, this.appId).then(res => {
        const data = res.data && res.data.data ? res.data.data : {}
        wx.config({
          debug: false,
          appId: data.appId,
          timestamp: data.timestamp,
          nonceStr: data.nonceStr,
          signature: data.signature,
          jsApiList: ['scanQRCode']
        })
        wx.ready(() => {
          this.wxReady = true
        })
        wx.error(err => {
          this.wxReady = false
          console.error('蘑菇家微信 JSSDK 配置失败:', err)
        })
      }).catch(err => {
        console.error('蘑菇家微信 JSSDK 初始化失败:', err)
      })
    },
    goToResult(code = '') {
      const targetUrl = new URL('/mogujia/result', window.location.origin)
      if (code) {
        targetUrl.searchParams.set('c', code)
      }
      window.location.href = targetUrl.toString()
    }
  }
}
</script>

<style scoped>
.mogujia-page {
  min-height: 100vh;
  min-height: 100dvh;
  height: 100vh;
  height: 100dvh;
  padding: calc(18vh + 24px) 22px 24px;
  padding: calc(18dvh + 24px) 22px 24px;
  box-sizing: border-box;
  overflow: hidden;
  background: url('/static/images/mogujia/bg.png') center center / cover no-repeat;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
}

.mogujia-card {
  position: relative;
  width: 85.5%;
  max-width: 456px;
  height: 53.45088vh;
  height: 53.45088dvh;
  max-height: 509px;
  margin: 0 auto;
  border-radius: 8px;
  background: rgb(243, 239, 230);
  box-shadow: 0 12px 32px rgba(86, 59, 35, 0.12);
  overflow: hidden;
}

.mogujia-card-top {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: min(3.8vh, 36px);
  padding-top: min(3.8dvh, 36px);
}

.mogujia-logo {
  width: clamp(66px, 15.8vw, 84px);
  display: block;
}

.mogujia-logo-cn {
  width: clamp(70px, 16.6vw, 88px);
  margin-top: 4px;
  display: block;
}

.mogujia-divider {
  position: absolute;
  top: min(17.536vh, 167px);
  top: min(17.536dvh, 167px);
  left: 0;
  width: 100%;
  height: 8px;
  background: linear-gradient(
    to bottom,
    rgba(183, 175, 164, 0.12) 0%,
    rgba(183, 175, 164, 0.06) 22%,
    rgba(243, 239, 230, 0) 100%
  );
  z-index: 1;
  pointer-events: none;
}

.mogujia-divider::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 1px;
  background: rgba(174, 165, 151, 0.24);
  filter: blur(0.8px);
  transform: scaleY(0.8);
  transform-origin: center top;
  opacity: 0.8;
}

.mogujia-divider::after {
  content: '';
  position: absolute;
  top: 1px;
  left: 0;
  width: 100%;
  height: clamp(10px, 2.45vw, 15px);
  background: linear-gradient(
    to bottom,
    rgba(154, 141, 125, 0.055) 0%,
    rgba(166, 154, 139, 0.04) 28%,
    rgba(182, 171, 156, 0.018) 58%,
    rgba(196, 187, 174, 0.008) 80%,
    rgba(243, 239, 230, 0) 100%
  );
  filter: blur(1.2px);
  pointer-events: none;
}

.mogujia-lock-wrap {
  position: absolute;
  top: calc(min(17.536vh, 167px) - clamp(54px, 10vw, 64px));
  top: calc(min(17.536dvh, 167px) - clamp(54px, 10vw, 64px));
  left: 45.5%;
  width: clamp(78px, 16vw, 92px);
  height: clamp(108px, 22vw, 128px);
  z-index: 2;
}

.mogujia-lock {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.mogujia-card-body {
  position: absolute;
  left: 0;
  right: 0;
  top: min(25.728vh, 245px);
  top: min(25.728dvh, 245px);
  bottom: 7%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 0 24px;
  box-sizing: border-box;
}

.scan-entry,
.confirm-entry {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  padding: 0;
}

.scan-entry {
  cursor: default;
  margin-top: clamp(12px, 2.8vw, 16px);
}

.confirm-entry {
  cursor: pointer;
}

.scan-icon {
  width: clamp(22px, 5.25vw, 27px);
  height: clamp(22px, 5.25vw, 27px);
  display: block;
}

.scan-tip {
  width: clamp(76px, 21vw, 94px);
  margin-top: clamp(10px, 2.2vw, 12px);
  display: block;
}

.or-img {
  width: clamp(10px, 2.8vw, 14px);
  margin-top: clamp(24px, 6vw, 30px);
  display: block;
}

.input-wrap {
  width: clamp(142px, 33vw, 158px);
  margin-top: clamp(20px, 5vw, 26px);
  padding-bottom: 3px;
  border-bottom: 1px solid rgba(196, 186, 172, 0.9);
}

.archive-input {
  width: 100%;
  border: none;
  padding: 0;
  background: transparent;
  font-family: inherit;
  color: #9d9487;
  font-size: clamp(11px, 2.8vw, 12px);
  line-height: 1.2;
  text-align: center;
  outline: none;
}

.archive-input::placeholder {
  color: #c5bdb2;
}

.archive-input:focus::placeholder {
  color: transparent;
}

.confirm-entry {
  margin-top: clamp(14px, 3.4vw, 18px);
}

.confirm-icon {
  width: clamp(20px, 5vw, 25px);
  height: clamp(20px, 5vw, 25px);
  display: block;
}

.confirm-text {
  width: clamp(62px, 17vw, 74px);
  margin-top: clamp(6px, 1.6vw, 8px);
  display: block;
}

@media (max-width: 480px) {
  .mogujia-page {
    padding: calc(17vh + 20px) 16px 20px;
    padding: calc(17dvh + 20px) 16px 20px;
  }

  .mogujia-card {
    width: 85.5%;
    height: 55.12122vh;
    height: 55.12122dvh;
    border-radius: 8px;
  }

  .mogujia-card-top {
    padding-top: min(4.6vh, 42px);
    padding-top: min(4.6dvh, 42px);
  }

  .mogujia-logo {
    width: clamp(64px, 19vw, 76px);
  }

  .mogujia-logo-cn {
    width: clamp(68px, 20vw, 80px);
  }

  .mogujia-divider {
    top: min(17.424vh, 161px);
    top: min(17.424dvh, 161px);
  }

  .mogujia-divider::after {
    height: clamp(8px, 2.8vw, 13px);
  }

  .mogujia-lock-wrap {
    top: calc(min(17.424vh, 161px) - 58px);
    top: calc(min(17.424dvh, 161px) - 58px);
    left: 45.5%;
    width: clamp(72px, 21vw, 84px);
    height: clamp(104px, 30vw, 118px);
  }

  .mogujia-card-body {
    top: min(25.872vh, 239px);
    top: min(25.872dvh, 239px);
    bottom: 6%;
    padding: 0 18px;
  }

  .scan-entry {
    margin-top: clamp(10px, 2.4vw, 14px);
  }

  .scan-icon {
    width: clamp(21px, 6vw, 25.5px);
    height: clamp(21px, 6vw, 25.5px);
  }

  .scan-tip {
    width: clamp(72px, 23vw, 88px);
    margin-top: clamp(8px, 2.4vw, 10px);
  }

  .or-img {
    width: clamp(10px, 2.9vw, 13px);
    margin-top: clamp(22px, 6vw, 28px);
  }

  .input-wrap {
    width: clamp(136px, 40vw, 152px);
    margin-top: clamp(18px, 5vw, 24px);
  }

  .archive-input {
    font-size: clamp(10px, 2.7vw, 11px);
  }

  .confirm-icon {
    width: clamp(19px, 5vw, 23px);
    height: clamp(19px, 5vw, 23px);
  }

  .confirm-text {
    width: clamp(58px, 18.5vw, 68px);
  }
}

@media (max-height: 580px) {
  .mogujia-page {
    padding: calc(14vh + 12px) 14px 12px;
    padding: calc(14dvh + 12px) 14px 12px;
  }

  .mogujia-card {
    width: 88.35%;
    height: 60.13224vh;
    height: 60.13224dvh;
    border-radius: 8px;
  }

  .mogujia-card-top {
    padding-top: min(3.2vh, 28px);
    padding-top: min(3.2dvh, 28px);
  }

  .mogujia-logo {
    width: clamp(58px, 18vw, 70px);
  }

  .mogujia-logo-cn {
    width: clamp(62px, 19vw, 74px);
  }

  .mogujia-divider {
    top: min(18.072vh, 153px);
    top: min(18.072dvh, 153px);
  }

  .mogujia-divider::after {
    height: clamp(7px, 2.2vw, 10px);
  }

  .mogujia-lock-wrap {
    top: calc(min(18.072vh, 153px) - 52px);
    top: calc(min(18.072dvh, 153px) - 52px);
    left: 45.5%;
    width: clamp(68px, 20vw, 76px);
    height: clamp(92px, 28vw, 106px);
  }

  .mogujia-card-body {
    top: min(24.624vh, 209px);
    top: min(24.624dvh, 209px);
    bottom: 4%;
    padding: 0 14px;
  }

  .scan-entry {
    margin-top: 8px;
  }

  .scan-icon {
    width: clamp(18px, 5.4vw, 22.5px);
    height: clamp(18px, 5.4vw, 22.5px);
  }

  .scan-tip {
    width: clamp(68px, 22vw, 82px);
    margin-top: 6px;
  }

  .or-img {
    width: clamp(10px, 2.8vw, 12px);
    margin-top: 18px;
  }

  .input-wrap {
    width: clamp(128px, 40vw, 144px);
    margin-top: 15px;
    padding-bottom: 3px;
  }

  .archive-input {
    font-size: clamp(9px, 2.6vw, 11px);
  }

  .confirm-entry {
    margin-top: 10px;
  }

  .confirm-icon {
    width: clamp(18px, 4.8vw, 22px);
    height: clamp(18px, 4.8vw, 22px);
  }

  .confirm-text {
    width: clamp(52px, 16.5vw, 62px);
    margin-top: 4px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MoGuJia/Scan.vue